import axios from 'axios';
import { stringify } from "qs";
import { showFormAlert } from '../general/form-ajax-alert';

const { site } = window.tg;
const bsn = require('bootstrap.native');
let bsnModal = new bsn.default.Modal('#js-modal');

/**
 * Opens specified modal
 * @param {string} target
 * @param {object} data
*/

const statusWARNING = 'WARNING';
const statusSUCCESS = 'SUCCESS';

function embeddedModal(target, data = {}) {

    // Remove all alerts
    var alerts = document.querySelectorAll(".modal-content .alert");
    alerts.forEach(alert => {
        alert.classList.add("d-none");
    });

    // Remove everything in parent div
    const parentDiv = document.getElementById("head-embedded");

    if (target === 'otp' && data.resend === "true") {
        let formEl = document.querySelector("#js-modal-otp-form");

        const btn_loader = '<div class="btn-loader"><div class="rect1"></div> <div class="rect2"></div> <div class="rect3"></div> <div class="rect4"></div> <div class="rect5"></div></div>';

        const submitEl = /** @type {HTMLButtonElement} */ (formEl.querySelectorAll('button[type="submit"]')[0]);
        if (!submitEl) {
            throw new Error('Submit button not found');
        }

        const submitElInnerHTML = submitEl.innerHTML;
        submitEl.style.width = (Math.ceil(submitEl.offsetWidth) + 1) + 'px'; // 2 for borders
        submitEl.disabled = true;
        submitEl.innerHTML = btn_loader;

        axios({
            url: '/backend/user/otp',
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: stringify({
                email: data.email,
                source: data.source,
                resend: true
            }),
        }).then((response) => {
            const output = response.data;
            let status = '';
            let reason = '';
            if (output.success) {
                status = statusSUCCESS;
            } else {
                status = statusWARNING;
            }
            if (output.data && output.data.reason) {
                reason = output.data.reason;
            } else {
                status = statusWARNING;
            }

            setTimeout(function () {
                submitEl.innerHTML = submitElInnerHTML;
                submitEl.disabled = false;
                showFormAlert(formEl.id, status, reason);
            }, 500)

        });
    } else {
        if (target !== undefined) {
            axios({
                url: '/backend/cms/modal',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: stringify({
                    target: target,
                    data: data
                }),
            }).then((response) => {
                parentDiv.innerHTML = "";
                const output = response.data;

                if (output.success) {
                    const data = output.data;
                    parentDiv.innerHTML = data['html'];
                }
            });
        }
    }

}

export { embeddedModal };
